import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';

class RefreshTokenTask extends AbstractRequestTask {
    constructor(params) {
        super();
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/user/v1/refresh_token`;
    }

    getParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.api_version;
        delete params.format;

        return { ...params };
    }

    success(data, b) {
        this.resolve(data);
    }

    getRetriesNumber() {
        return 0;
    }

    isValid(data) {
        if (data.errors || !data.data || data.data === 'errors') {
            return false;
        }

        return true;
    }
}

export default RefreshTokenTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/RefreshTokenTask.js